import { useEffect, useState } from 'react';
import '../styles/landing-page.css';
import Header from '../components/Header.jsx';
import FeatureCard from '../components/FeatureCard.jsx';

const CARD_IMAGE_DASHBOARD = '/images/card-dashboard.png';
const CARD_IMAGE_LIFE = '/images/card-life.png';
const CARD_IMAGE_AWS = '/images/card-aws-billing.png';

const FEATURES = [
	{
		title: 'Dashboard',
		subtitle: 'プロジェクト可視化ダッシュボード',
		image: CARD_IMAGE_DASHBOARD,
		href: '/dashboard',
		functionName: 'ダッシュボード',
	},
	{
		title: 'Life',
		subtitle: '座席くじ',
		image: CARD_IMAGE_LIFE,
		href: '/life',
		functionName: 'Life',
	},
	{
		title: 'AWS Billing Monitor',
		subtitle: 'AWS使用量可視化ダッシュボード',
		image: CARD_IMAGE_AWS,
		href: '/aws-billing',
		functionName: 'AWS利用料',
	},
];

// 件数に依存する循環の検証をテスト側で書けるよう公開する
export const HERO_MESSAGES = [
	{
		title: '「心を高める」',
		subtitle: '動機善なりや、私心なかりしか',
	},
	{
		title: '「村形仕事しろ」',
		subtitle: 'スキーばっかり行ってないで',
	},
	{
		title: '「目指す姿」',
		subtitle: '夢を描き、追い続ける',
	},
	{
		title: '「小幡仕事しろ」',
		subtitle: 'タバコばっかり吸ってないで',
	},
	{
		title: '「経営の原則」',
		subtitle: '事業の目的、意義を明確にする',
	},
	{
		title: '「田村骨折」',
		subtitle: 'Yの覇気に負けた',
	},
	{
		title: '「行動の原則」',
		subtitle: 'フェアプレイ精神を貫く',
	},
	{
		title: '「石山 電子で勝負」',
		subtitle: 'ブラックデビル卒業',
	},
	{
		title: '「行動指針」',
		subtitle: '闘争心を燃やす',
	},
	{
		title: '「金城ダーツやれ」',
		subtitle: 'レート下げてる場合じゃない',
	},
	{
		title: '「目指す姿」',
		subtitle: '365日守るのが使命',
	},
	{
		title: '「小暮最高」',
		subtitle: 'よく一人で作ったなぁ',
	},
	{
		title: '「心を高める」',
		subtitle: '常に謙虚に素直な心で',
	},
	{
		title: '「山本」',
		subtitle: 'メッセージ募集中',
	},
];

export default function LandingPage() {
	const [heroIndex, setHeroIndex] = useState(0);

	useEffect(() => {
		const timer = window.setInterval(() => {
			setHeroIndex((prev) => (prev + 1) % HERO_MESSAGES.length);
		}, 5000);

		return () => {
			window.clearInterval(timer);
		};
	}, []);

	const currentHero = HERO_MESSAGES[heroIndex];

	return (
		<div className="landing-page" data-node-id="42:2">
			<Header rightLinks={[]} />

			<main className="landing-main" data-node-id="47:12">
				<section className="hero" data-node-id="47:13">
					<p className="hero-title" data-node-id="47:14">{currentHero.title}</p>
					<p className="hero-subtitle" data-node-id="47:16">{currentHero.subtitle}</p>
				</section>

				<section className="cards-row" data-node-id="47:17">
					{FEATURES.map((feature) => (
						<FeatureCard
							key={feature.title}
							href={feature.href}
							image={feature.image}
							subtitle={feature.subtitle}
							title={feature.title}
						/>
					))}
				</section>
			</main>
		</div>
	);
}
